import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import styles from "./Pages.module.css";

function ManagedITShreveport() {
  return (
    <div className={`${styles.pageWrapper} ${styles.localSeoPage}`}>
      <Helmet>
        <title>Managed IT Services in Shreveport-Bossier City | Tharpe Industries</title>
        <meta name="description" content="Managed IT services for small businesses in Shreveport and Bossier City. Monthly IT support plans starting at $99/mo, local technician, no contracts, no call centers." />
        <meta name="keywords" content="managed IT services Shreveport, IT support company Shreveport, small business IT support Bossier City, monthly IT support Louisiana, local IT company Shreveport" />
        <link rel="canonical" href="https://tharpeindustries.com/managed-it-services-shreveport" />
      </Helmet>

      <div className={styles.pageHero}>
        <div className={styles.contentContainer}>
          <p className={styles.sectionEyebrow}>Shreveport & Bossier City</p>
          <h1>Managed IT Services, Shreveport-Bossier</h1>
          <p className={styles.heroSubtext}>Monthly IT support for small businesses in Shreveport and Bossier City. Austin Tharpe handles your computers, network, backups, and security, so technology problems stop interrupting your workday.</p>
          <div className={styles.heroCtas}>
            <Link to="/it-health-check" className="btn btn-primary">Start with the $149 IT Health Check</Link>
            <Link to="/managed-it-services" className={styles.heroSecondaryLink}>See plan details</Link>
          </div>
        </div>
      </div>

      <div className={styles.pageSection}>
        <div className={styles.contentContainer}>
          <div className={styles.textContent}>

            <h2>What "managed IT" actually means for a small business in Shreveport</h2>
            <p>Managed IT means you pay a flat monthly fee and a local technician handles your technology, instead of calling someone every time something breaks and paying by the hour. You get proactive monitoring, regular maintenance, and a person you can actually reach when something goes wrong.</p>
            <p>For small businesses in Shreveport and Bossier City, that means you stop losing hours to IT problems. Your computers stay updated. Your backups actually run. And when something does go wrong, you have someone who knows your setup already, not a random support line.</p>

            <h2>What's included in a monthly IT plan from Tharpe Industries</h2>
            <ul className={styles.benefitList}>
              <li><strong>Remote monitoring:</strong> Ongoing monitoring of your computers and network for issues before they become problems, disk failures, security alerts, software updates.</li>
              <li><strong>Patch management:</strong> Windows and software updates applied on a schedule, not randomly. Security patches handled promptly.</li>
              <li><strong>Backup monitoring:</strong> Verify your backups are actually running and completing, not just set-and-forget.</li>
              <li><strong>Remote support:</strong> When something breaks, connect remotely and fix it without waiting for a site visit.</li>
              <li><strong>Antivirus and security:</strong> Managed endpoint protection, not just a free antivirus you installed and forgot about.</li>
              <li><strong>Priority scheduling:</strong> Members get priority over break-fix calls. You're not waiting in line behind someone who isn't a client.</li>
            </ul>

            <h2>Monthly IT plans, Shreveport-Bossier pricing</h2>
            <ul className={styles.benefitList}>
              <li><strong>Basic, $99/mo:</strong> Remote monitoring, patch management, backup verification for 1-2 devices. Good for solo operators and very small offices.</li>
              <li><strong>Standard, $149/mo:</strong> Everything in Basic plus antivirus management and priority remote support for up to 5 devices. Most common plan for small businesses.</li>
              <li><strong>Professional, $199/mo:</strong> Everything in Standard plus network monitoring, advanced security reporting, and quarterly review calls for larger offices or compliance-sensitive businesses.</li>
            </ul>
            <p>All plans are month-to-month. No annual contracts. Cancel anytime.</p>

            <h2>Why hire a local IT company instead of a national MSP?</h2>
            <p>National MSPs use tiered support desks. You call a number, get triaged, and eventually reach someone who doesn't know your business. When something needs hands-on attention, they send whoever is available.</p>
            <p>With a local technician, you work with the same person every time. Austin knows your setup, your history, and your priorities. Remote support is faster when someone already knows your environment. On-site visits are scheduled with you directly, not through a dispatch system.</p>
            <p>For Shreveport and Bossier City small businesses, that local relationship is the difference between IT support that actually works and IT support that just generates tickets.</p>

            <h2>Not sure if managed IT is right for your business?</h2>
            <p>The $149 IT Health Check is the natural first step. I review your current setup, computers, network, backups, and security, and give you a clear picture of what's working, what's not, and what a monthly plan would actually cover for your specific situation. No sales pitch. You can decide after seeing the report.</p>

            <div className={styles.relatedPages}>
              <p className={styles.relatedPagesHeading}>Related:</p>
              <div className={styles.relatedPageLinks}>
                <Link to="/computer-repair-shreveport">Computer Repair, Shreveport</Link>
                <Link to="/managed-it-services">Managed IT Plan Details</Link>
                <Link to="/it-health-check">IT Health Check, $149</Link>
                <Link to="/managed-it-vs-break-fix">Managed IT vs Break/Fix</Link>
                <Link to="/cybersecurity">Cybersecurity</Link>
                <Link to="/data-backup-recovery">Data Backup & Recovery</Link>
              </div>
            </div>

            <div style={{ marginTop: '2rem' }}>
              <p><strong>Ready to get started?</strong> <Link to="/it-health-check">Book the IT Health Check</Link> and I'll review your setup and walk you through which plan fits your business.</p>
              <p>Questions first? <Link to="/contact-us">Send me a message</Link> and I'll follow up by email.</p>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}

export default ManagedITShreveport;
